import "./TerminalWindow.css";

export default function TerminalWindow({
  title = "",
  children,
  className = "",
  bodyClassName = "",
}) {
  return (
    <div className={`term ${className}`}>
      <div className="term-bar">
        <div className="term-dots">
          <span className="term-dot" />
          <span className="term-dot" />
          <span className="term-dot" />
        </div>
        {title && <span className="term-title">{title}</span>}
      </div>
      <div className={`term-body ${bodyClassName}`}>{children}</div>
    </div>
  );
}
